import React, { HTMLAttributeAnchorTarget } from 'react';
import clsx from 'clsx';
import { ExternalLink } from 'react-feather';

export type StyledLinkProps = {
  className?: string;
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  children: React.ReactNode;
  hidden?: boolean;
  hover?: boolean;
};

export default function StyledLink({
  className,
  href,
  children,
  target,
  hidden = false,
  hover = true,
}: StyledLinkProps) {
  const linkClassName = clsx(
    'text-brand font-semibold inline-flex items-center',
    { 'hover:underline': hover },
    className,
  );
  return (
    <a className={linkClassName} href={href} target={target}>
      {children}

      {target === '_blank' && !hidden && (
        <div className="ml-1">
          <ExternalLink size={18} />
        </div>
      )}
    </a>
  );
}
